import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AlertService } from '../../../services/shared/alert/alert.service';
import { ScorecardRefreshService } from '../../../services/shared/alert/scorecard-refresh.service';

@Component({
  selector: 'app-alert-container',
  standalone: true,
  templateUrl: './alert-container.component.html',
  styleUrl: './alert-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertContainerComponent {
  readonly alertService = inject(AlertService);
  private readonly refreshService = inject(ScorecardRefreshService);

  isCollapsed = false;

  dismiss(alertId: string): void {
    this.alertService.dismiss(alertId);
  }

  dismissAll(): void {
    this.alertService.dismissAll();
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  refreshScores(): void {
    this.refreshService.triggerRefresh();
  }
}
